import React, { useRef, useEffect } from 'react'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const ScrollHintModule = (block) => {
  const refScrollHintScroll = useRef(null)

  useEffect(() => {
    gsap.from(refScrollHintScroll.current, {
      //duration: 1,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: refScrollHintScroll.current,
        toggleActions: 'play none none none',
        start: 'bottom bottom=-40px',
        end: 99999,
        toggleClass: 'scroll-hint-hidden',
      },
    })
  }, [])
  return (
    <div ref={refScrollHintScroll} className="scroll-hint">
      <i className="fas fa-angle-down"></i>
    </div>
  )
}

export default ScrollHintModule
